import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DownloadLiner24 = _ref => {
  let {
    width = 24,
    height = 24
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: "".concat(width),
    height: "".concat(height),
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.75 10.4596V14.2906C15.75 14.6777 15.592 15.0489 15.3107 15.3225C15.0294 15.5962 14.6478 15.75 14.25 15.75L3.75 15.75C3.35218 15.75 2.97064 15.5962 2.68934 15.3225C2.40804 15.0489 2.25 14.6777 2.25 14.2906L2.25 10.4596M5.35126 7.35849L8.99989 11.007M8.99989 11.007L12.6485 7.3585M8.99989 11.007L8.99986 2.25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};